import React from "react"
import { Routes, Route } from "react-router-dom"
import "./App.css"
import Layout from "./component/common/Layout"
import HomePage from "./pages/Home"
import IntrovertInsights from "./pages/IntrovertInsights"
import IntrovertEmpowerment from "./pages/IntrovertEmpowerment"
import Resources from "./pages/Resources"
import AboutPage from "./pages/About"
import FeedbackPage from "./pages/Feedback"
import NotFoundPage from "./pages/NotFound"

const App = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="introvert-insights" element={<IntrovertInsights />} />
          <Route
            path="introvert-empowerment"
            element={<IntrovertEmpowerment />}
          />
          <Route path="resources" element={<Resources />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="feedback" element={<FeedbackPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </>
  )
}

export default App
